export function encodeRecord(r) {
    return new TextEncoder().encode(JSON.stringify(r));
}
export function decodeRecord(b) {
    return JSON.parse(new TextDecoder().decode(b));
}
/** Split a .meta object (length-prefixed sealed frames) into its sealed records. */
export function splitMetaObject(data) {
    const out = [];
    let off = 0;
    while (off + 4 <= data.length) {
        const len = new DataView(data.buffer, data.byteOffset + off).getUint32(0);
        off += 4;
        if (off + len > data.length)
            break;
        out.push(data.slice(off, off + len));
        off += len;
    }
    return out;
}
//# sourceMappingURL=metadata.js.map